import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Rightchat from "../components/Rightchat";
import Appfooter from "../components/Appfooter";
import Popupchat from "../components/Popupchat";

import { fetchMatrimonyProfiles } from "../redux/slices/materimonySlice";

const API_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
)
  .replace(/\/uploads\/?$/, "")
  .replace(/\/$/, "");

const MatrimonyPortalPage: React.FC = () => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const selectedClient = JSON.parse(localStorage.getItem("selectedClient") || "{}");
  const loggedClient = JSON.parse(localStorage.getItem("client") || "{}");

  const userId =
    user?.user_id || selectedClient?.user_id || loggedClient?.user_id || null;

  const { profiles = [], loading } = useSelector(
    (state: any) => state.matrimony
  );

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [selectedCaste, setSelectedCaste] = useState("");

  useEffect(() => {
    dispatch(
      fetchMatrimonyProfiles(
        userId || null
      )
    );
  }, [dispatch, userId]);

  const uniqueCastes = useMemo(() => {
    const castes = new Set<string>();

    profiles.forEach((profile: any) => {
      if (profile.caste) {
        castes.add(String(profile.caste));
      }
    });

    return Array.from(castes);
  }, [profiles]);

  const filteredProfiles = useMemo(() => {
    let list = profiles || [];

    if (selectedGender) {
      list = list.filter(
        (profile: any) =>
          profile.gender?.toLowerCase() === selectedGender.toLowerCase()
      );
    }

    if (selectedCaste) {
      list = list.filter(
        (profile: any) =>
          profile.caste?.toLowerCase() === selectedCaste.toLowerCase()
      );
    }

    if (searchTerm.trim()) {
      const search = searchTerm.toLowerCase();

      list = list.filter(
        (profile: any) =>
          profile.full_name?.toLowerCase().includes(search) ||
          profile.city?.toLowerCase().includes(search) ||
          profile.education?.toLowerCase().includes(search) ||
          profile.occupation?.toLowerCase().includes(search)
      );
    }

    return list;
  }, [profiles, searchTerm, selectedGender, selectedCaste]);

  const handleViewProfile = (matrimonyId: number) => {
    navigate(`/matrimony/viewprofile/${matrimonyId}`);
  };

  const getProfilePhoto = (profile: any) => {
    if (!profile?.profile_photo) {
      return "/assets/images/user.png";
    }

    const value = String(profile.profile_photo).trim();

    if (
      value.startsWith("http://") ||
      value.startsWith("https://")
    ) {
      return encodeURI(value);
    }

    if (value.startsWith("/uploads/")) {
      return encodeURI(`${API_URL}${value}`);
    }

    if (value.startsWith("uploads/")) {
      return encodeURI(`${API_URL}/${value}`);
    }

    if (value.startsWith("/")) {
      return encodeURI(`${API_URL}${value}`);
    }

    return encodeURI(
      `${API_URL}/uploads/matrimony/${value}`
    );
  };

  return (
    <Fragment>
      <Header />
      <Leftnav />
      <Rightchat />

      <div className="main-content right-chat-active matrimony-main-page">
        <div className="middle-sidebar-bottom matrimony-middle-bottom">
          <div className="middle-sidebar-left matrimony-middle-left">
            <div className="matrimony-page-wrapper">
              <div className="matrimony-header-card">
                <div className="matrimony-header-top">
                  <div>
                    <span className="community-badge">Community Matrimony</span>

                    <h2 className="matrimony-title">Matrimony Profiles</h2>

                    <p className="matrimony-subtitle">
                      Browse approved matrimony profiles from this community.
                    </p>
                  </div>

                  <div className="matrimony-count-box">
                    <strong>{filteredProfiles.length}</strong>
                    <span>Profiles</span>
                  </div>
                </div>

                <div className="matrimony-filter-row">
                  <div className="matrimony-select-wrap">
                    <select
                      value={selectedGender}
                      onChange={(e) => setSelectedGender(e.target.value)}
                    >
                      <option value="">All Genders</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>

                    <i className="feather-chevron-down" />
                  </div>

                  <div className="matrimony-select-wrap">
                    <select
                      value={selectedCaste}
                      onChange={(e) => setSelectedCaste(e.target.value)}
                    >
                      <option value="">All Castes</option>

                      {uniqueCastes.map((caste) => (
                        <option key={String(caste)} value={String(caste)}>
                          {String(caste)}
                        </option>
                      ))}
                    </select>

                    <i className="feather-chevron-down" />
                  </div>

                  <div className="matrimony-search-box">
                    <i className="feather-search" />

                    <input
                      type="text"
                      placeholder="Search by name, city, education..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              {loading ? (
                <div className="matrimony-loader-card">
                  <div className="spinner-border text-primary" />
                  <p>Loading profiles...</p>
                </div>
              ) : filteredProfiles.length > 0 ? (
                <div className="matrimony-profile-list">
                  {filteredProfiles.map((profile: any) => (
                    <div
                      className="matrimony-profile-card"
                      key={profile.matrimony_id}
                    >
                      <div className="matrimony-profile-image">
                        <img
                          src={getProfilePhoto(profile)}
                          alt={profile.full_name || "Profile"}
                          onError={(e: any) => {
                            e.currentTarget.src = "/assets/images/user.png";
                          }}
                        />

                        <div className="profile-top-tags">
                          <span className="profile-gender-tag">
                            {profile.gender || "--"}
                          </span>

                          <span className="profile-age-tag">
                            {profile.age || "--"} yrs
                          </span>
                        </div>

                        <div className="profile-image-overlay">
                          <h3>{profile.full_name || "-"}</h3>

                          <div className="profile-location">
                            <i className="feather-map-pin" />

                            <span>
                              {profile.city || "--"}
                              {profile.state ? `, ${profile.state}` : ""}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="matrimony-profile-details">
                        <div className="profile-info-grid">
                          <div className="profile-info-card">
                            <label>Caste</label>
                            <h5>{profile.caste || "--"}</h5>
                          </div>

                          <div className="profile-info-card">
                            <label>{profile.bari ? "Bari" : "Gotra"}</label>
                            <h5>{profile.bari || profile.gothra || "--"}</h5>
                          </div>

                          <div className="profile-info-card">
                            <label>Education</label>
                            <h5>{profile.education || "--"}</h5>
                          </div>

                          <div className="profile-info-card">
                            <label>Occupation</label>
                            <h5>{profile.occupation || "--"}</h5>
                          </div>

                          <div className="profile-info-card">
                            <label>Annual Income</label>
                            <h5>
                              {profile.annual_income
                                ? `₹${Number(
                                    profile.annual_income
                                  ).toLocaleString("en-IN")}`
                                : "--"}
                            </h5>
                          </div>

                          <div className="profile-info-card">
                            <label>Height</label>
                            <h5>
                              {profile.height_cm
                                ? `${profile.height_cm} cm`
                                : "--"}
                            </h5>
                          </div>
                        </div>

                        <div className="profile-action-buttons">
                          <button
                            className="profile-view-btn"
                            onClick={() =>
                              handleViewProfile(profile.matrimony_id)
                            }
                          >
                            View Profile
                            <i className="feather-arrow-right ms-2" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="matrimony-empty-card">
                  <div className="matrimony-empty-avatar">
                    <i className="feather-heart" />
                  </div>

                  <h4>
                    {searchTerm ||
                    selectedGender ||
                    selectedCaste
                      ? "No Profiles Found"
                      : "No Matrimony Profiles Available"}
                  </h4>

                  <p>
                    {searchTerm ||
                    selectedGender ||
                    selectedCaste
                      ? "Try changing your search or filters."
                      : "Approved matrimony profiles will appear here when available."}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Popupchat />
      <Appfooter />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:wght@600;700&family=Inter:wght@400;500;600;700&display=swap');

        .matrimony-main-page {
          width: 100%;
          min-height: 100vh;
          padding-top: 58px;
          padding-left: 285px;
          padding-right: 315px;
          overflow-x: hidden;
          font-family: 'Inter', sans-serif;
          background: linear-gradient(180deg, #f8f9fc 0%, #f1f3f8 100%);
        }

        .matrimony-middle-bottom,
        .matrimony-middle-left {
          width: 100%;
          max-width: 100%;
        }

        .matrimony-page-wrapper {
          width: 100%;
          max-width: 900px;
          margin-left: 22px;
          margin-top: 28px;
          padding-bottom: 40px;
        }

        /* ==========================
           HEADER
        ========================== */

        .matrimony-header-card {
          margin-bottom: 18px;
          padding: 14px 16px;
          border: 1px solid #e2eaf6;
          border-radius: 16px;
          background:
            linear-gradient(
              135deg,
              #ffffff 0%,
              #f7faff 58%,
              #f1f6ff 100%
            );
          box-shadow: 0 5px 16px rgba(10, 35, 84, 0.045);
        }

        .matrimony-header-top {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 12px;
          margin-bottom: 10px;
        }

        .community-badge {
          display: none;
        }

        .matrimony-title {
          margin: 0 0 4px;
          color: #0A2354;
          font-family: 'Fraunces', serif;
          font-size: 24px;
          font-weight: 700;
          line-height: 1.25;
          letter-spacing: -0.01em;
        }

        .matrimony-subtitle {
          margin: 0;
          color: #8a93a3;
          font-size: 13px;
          line-height: 1.5;
          font-weight: 400;
        }

        .matrimony-count-box {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          min-height: 26px;
          padding: 0 9px;
          flex-shrink: 0;
          border: 1px solid #dce7f7;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.78);
          white-space: nowrap;
        }

        .matrimony-count-box strong,
        .matrimony-count-box span {
          display: inline;
          margin: 0;
          color: #5f7fae;
          font-size: 11px;
          font-weight: 700;
          line-height: 1;
        }

        /* ==========================
           FILTERS
        ========================== */

        .matrimony-filter-row {
          display: grid;
          grid-template-columns: 150px 170px minmax(0, 1fr);
          gap: 10px;
          align-items: center;
        }

        .matrimony-select-wrap {
          position: relative;
          height: 40px;
        }

        .matrimony-select-wrap select {
          width: 100%;
          height: 40px;
          border: 1px solid #e5e8ef;
          border-radius: 10px;
          padding: 0 34px 0 12px;
          appearance: none;
          outline: none;
          color: #475569;
          background: rgba(255, 255, 255, 0.92);
          font-size: 12px;
          font-weight: 600;
          box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.04);
        }

        .matrimony-select-wrap select:focus {
          border-color: #2F6FE4;
          box-shadow: 0 0 0 3px rgba(47, 111, 228, 0.10);
        }

        .matrimony-select-wrap i {
          position: absolute;
          right: 12px;
          top: 50%;
          color: #94a3b8;
          font-size: 14px;
          transform: translateY(-50%);
          pointer-events: none;
        }

        .matrimony-search-box {
          position: relative;
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
        }

        .matrimony-search-box i {
          position: absolute;
          left: 14px;
          top: 50%;
          z-index: 1;
          color: #9aa4b2;
          font-size: 14px;
          transform: translateY(-50%);
          pointer-events: none;
        }

        .matrimony-search-box input {
          width: 100%;
          height: 40px;
          border: 1px solid #e5e8ef;
          border-radius: 10px;
          padding: 0 12px 0 36px;
          outline: none;
          color: #1f2937;
          background: rgba(255, 255, 255, 0.92);
          font-size: 13px;
          box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.05);
          transition: box-shadow 0.2s ease, border-color 0.2s ease;
        }

        .matrimony-search-box input::placeholder {
          color: #9aa4b2;
        }

        .matrimony-search-box input:focus {
          border-color: #2F6FE4;
          box-shadow:
            inset 0 1px 2px rgba(15, 23, 42, 0.04),
            0 0 0 3px rgba(47, 111, 228, 0.10);
        }

        /* ==========================
           PROFILE LIST
        ========================== */

        .matrimony-profile-list {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .matrimony-profile-card {
          display: flex;
          width: 100%;
          overflow: hidden;
          border: 1px solid #e9ecf2;
          border-radius: 16px;
          background: #ffffff;
          box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);
          transition:
            transform 0.2s ease,
            border-color 0.2s ease,
            box-shadow 0.2s ease;
        }

        .matrimony-profile-card:hover {
          transform: translateY(-2px);
          border-color: #c9d9f8;
          box-shadow: 0 12px 28px rgba(10, 35, 84, 0.10);
        }

        .matrimony-profile-image {
          position: relative;
          width: 220px;
          min-width: 220px;
          min-height: 275px;
          overflow: hidden;
          background: #eef1f6;
        }

        .matrimony-profile-image img {
          position: absolute;
          inset: 0;
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.35s ease;
        }

        .matrimony-profile-card:hover .matrimony-profile-image img {
          transform: scale(1.03);
        }

        .profile-top-tags {
          position: absolute;
          top: 10px;
          left: 10px;
          right: 10px;
          z-index: 2;
          display: flex;
          justify-content: space-between;
          gap: 8px;
        }

        .profile-gender-tag,
        .profile-age-tag {
          display: inline-flex;
          align-items: center;
          min-height: 24px;
          padding: 0 8px;
          border: 1px solid rgba(255, 255, 255, 0.65);
          border-radius: 999px;
          color: #0A2354;
          background: rgba(255, 255, 255, 0.92);
          font-size: 10px;
          font-weight: 700;
          text-transform: capitalize;
          backdrop-filter: blur(3px);
        }

        .profile-image-overlay {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 2;
          padding: 14px;
          background: linear-gradient(
            to top,
            rgba(10, 35, 84, 0.88),
            rgba(10, 35, 84, 0.28) 62%,
            transparent
          );
        }

        .profile-image-overlay h3 {
          margin: 0 0 4px;
          color: #ffffff;
          font-family: 'Fraunces', serif;
          font-size: 18px;
          font-weight: 700;
          line-height: 1.3;
        }

        .profile-location {
          display: flex;
          align-items: center;
          gap: 5px;
          color: rgba(255, 255, 255, 0.88);
          font-size: 11px;
          font-weight: 500;
        }

        .matrimony-profile-details {
          min-width: 0;
          flex: 1;
          padding: 14px;
        }

        .profile-info-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 8px;
        }

        .profile-info-card {
          min-width: 0;
          padding: 10px;
          border: 1px solid #edf1f6;
          border-radius: 10px;
          background: #f8fafc;
        }

        .profile-info-card label {
          display: block;
          margin-bottom: 4px;
          color: #94a3b8;
          font-size: 10.5px;
          font-weight: 600;
        }

        .profile-info-card h5 {
          margin: 0;
          overflow: hidden;
          color: #0f1b34;
          font-size: 12.5px;
          font-weight: 600;
          line-height: 1.35;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .profile-action-buttons {
          display: flex;
          justify-content: flex-end;
          margin-top: 12px;
        }

        .profile-view-btn {
          min-width: 150px;
          min-height: 34px;
          padding: 0 12px;
          border: 1px solid #2F6FE4;
          border-radius: 10px;
          outline: none;
          color: #ffffff;
          background: #2F6FE4;
          font-size: 11px;
          font-weight: 700;
          cursor: pointer;
          transition:
            background 0.2s ease,
            transform 0.2s ease;
        }

        .profile-view-btn:hover {
          background: #1f57c7;
          transform: translateY(-1px);
        }

        /* ==========================
           LOADING / EMPTY
        ========================== */

        .matrimony-loader-card,
        .matrimony-empty-card {
          width: 100%;
          min-height: 200px;
          padding: 28px 22px;
          border: 1px dashed #dbe2ec;
          border-radius: 16px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          background: #ffffff;
          box-shadow: none;
        }

        .matrimony-loader-card p {
          margin: 10px 0 0;
          color: #94a3b8;
          font-size: 11.5px;
        }

        .matrimony-empty-avatar {
          width: 44px;
          height: 44px;
          margin-bottom: 11px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #5f7fae;
          background: #eef4fb;
          font-size: 20px;
        }

        .matrimony-empty-card h4 {
          margin: 0;
          color: #475569;
          font-size: 14px;
          font-weight: 700;
        }

        .matrimony-empty-card p {
          max-width: 330px;
          margin: 6px 0 0;
          color: #94a3b8;
          font-size: 11.5px;
          line-height: 1.55;
        }

        /* ==========================
           RESPONSIVE
        ========================== */

        @media (max-width: 1400px) {
          .matrimony-main-page {
            padding-right: 290px;
          }
        }

        @media (max-width: 1200px) {
          .matrimony-main-page {
            padding-left: 20px;
            padding-right: 20px;
          }

          .matrimony-page-wrapper {
            margin-left: 0;
            max-width: 100%;
          }
        }

        @media (max-width: 900px) {
          .matrimony-filter-row {
            grid-template-columns: 1fr 1fr;
          }

          .matrimony-search-box {
            grid-column: 1 / -1;
          }

          .matrimony-profile-card {
            flex-direction: column;
          }

          .matrimony-profile-image {
            width: 100%;
            min-width: 100%;
            height: 320px;
            min-height: 320px;
          }
        }

        @media (max-width: 768px) {
          .matrimony-main-page {
            padding-top: 16px;
            padding-left: 12px;
            padding-right: 12px;
          }

          .matrimony-middle-bottom,
          .matrimony-middle-left {
            padding-left: 0 !important;
            padding-right: 0 !important;
            margin-left: 0 !important;
            margin-right: 0 !important;
          }

          .matrimony-page-wrapper {
            margin-top: 0;
            margin-left: 0;
            max-width: 100%;
            padding-bottom: 76px;
          }

          .matrimony-header-card {
            padding: 12px 13px;
            border-radius: 14px;
          }

          .matrimony-title {
            font-size: 21px;
          }

          .matrimony-filter-row {
            grid-template-columns: 1fr;
          }

          .matrimony-search-box {
            grid-column: auto;
          }

          .matrimony-profile-card {
            border-radius: 14px;
          }

          .matrimony-profile-image {
            height: 285px;
            min-height: 285px;
          }
        }

        @media (max-width: 480px) {
          .matrimony-header-top {
            flex-direction: column;
          }

          .profile-info-grid {
            grid-template-columns: 1fr;
          }

          .profile-action-buttons {
            justify-content: stretch;
          }

          .profile-view-btn {
            width: 100%;
          }
        }
      `}</style>
    </Fragment>
  );
};

export default MatrimonyPortalPage;